import type { ReactNode } from 'react'
import { ChevronRightIcon } from '@/design-system/icons'

interface Props {
  icon?: ReactNode
  iconColor?: string
  title: ReactNode
  subtitle?: ReactNode
  trailing?: ReactNode
  onClick?: () => void
  disabled?: boolean
}

export function ListRow({ icon, iconColor, title, subtitle, trailing, onClick, disabled }: Props) {
  const inner = (
    <div className="flex items-center gap-3 py-3 px-1">
      {icon && (
        <div
          className="flex h-10 w-10 items-center justify-center rounded-r-sm shrink-0"
          style={{ background: (iconColor ?? '#F4EFE7') + '18', color: iconColor ?? '#F4EFE7' }}
        >
          {icon}
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="text-body text-text-primary font-medium truncate">{title}</div>
        {subtitle && <div className="text-caption text-text-tertiary mt-0.5 truncate">{subtitle}</div>}
      </div>
      {trailing ?? (onClick && !disabled ? <ChevronRightIcon size={18} className="text-text-quiet shrink-0" /> : null)}
    </div>
  )

  if (onClick && !disabled) {
    return (
      <button type="button" onClick={onClick} className="block w-full text-left active:bg-white/5 rounded-r-sm">
        {inner}
      </button>
    )
  }
  return inner
}
